// Oylan stand: a drawing of the lesson «Сколько тут фигур» (oylan/figures.py exports it).
// figure = {w, h, lines: [[x1, y1, x2, y2], ...]}, the longest side 100; shape = points of one filled shape.
import React from "react";

const PAD = 6;

export function Figure({ figure, shape, width = 320 }) {
    const w = figure.w + 2 * PAD, h = figure.h + 2 * PAD;
    return (
        <svg viewBox={`${-PAD} ${-PAD} ${w} ${h}`} width={width} height={Math.round(width * h / w)} style={{ display: "block" }}>
            {shape && <polygon points={shape.map((p) => p.join(",")).join(" ")} fill="#ffb74d" fillOpacity={0.75} />}
            <g stroke="#222" strokeWidth={1.6} strokeLinecap="round">
                {figure.lines.map(([x1, y1, x2, y2], i) => <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />)}
            </g>
        </svg>
    );
}

// Every shape of one step, each filled on its own small copy of the drawing: the child sees what was counted.
export function Shapes({ figure, shapes }) {
    if (!figure || !shapes || shapes.length === 0) return null;
    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 }} data-testid="step-shapes">
            {shapes.map((s, i) => (
                <div key={i} style={{ background: "#fff", borderRadius: 6, padding: 4, textAlign: "center", fontSize: "0.9rem", color: "#555" }}>
                    <Figure figure={figure} shape={s} width={84} />{i + 1}
                </div>
            ))}
        </div>
    );
}
